<template>
  <div class="block-agreement agreement modal">
    <div class="blacking" @click="hideSelf"></div>
    <div class="agreement__container">
      <img
        src="../images/utils/close-black.svg"
        alt="Закрыть"
        class="thanks__close"
        @click="hideSelf"
      />
      <div class="agreement__content">
        <h3 class="agreement__title">
          СОГЛАСИЕ<br />
          на обработку персональных данных и получение рекламы<br />
          (далее – «Согласие»)
        </h3>
        <template v-if="type === 'personal'">
          <div class="agreement__paragraph">
            Настоящим даю согласие на обработку моих вышеуказанных
            персональных данных Операторам: Оператор 1: ООО «ФОЛЬКСВАГЕН Груп
            Рус» (248926, г. Калуга, ул. Автомобильная, д. 1 / (почтовый адрес)
            адрес Филиала в г. Москве: 117485, г. Москва, ул. Обручева, д.
            30/1); Оператор 2: ООО "РОЛЬФ", Филиал АЦ Север (125445, г. Москва,
            Ленинградское ш., д. 63Б) (прим: точная информация об Операторе 2
            (фирменное наименование и юридический адрес) размещена на
            официальном сайте Оператора 2) с целями: обработки моего запроса,
            направленного посредством заполнения соответствующих форм на
            интернет-сайтах Операторов, и коммуникации со мной в целях,
            связанных с обработкой и выполнением моего запроса с помощью
            различных средств связи, а именно посредством: интернет; сообщений
            на адрес электронной почты; коротких текстовых сообщений (SMS) и
            мультимедийных сообщений (MMS) на номер телефона; а также
            посредством использования информационно-коммуникационных сервисов,
            таких как Viber, WhatsApp и тому подобных; телефонных звонков.
          </div>
          <div class="agreement__paragraph">
            Я разрешаю совершать со своими персональными данными следующие
            действия: сбор, систематизацию, накопление, хранение (в электронном
            виде и на бумажном носителе), уточнение (обновление, изменение),
            использование, распространение (в том числе передачу) моих
            персональных данных третьим лицам, с которыми у Оператора имеются
            действующие договоры, в рамках которых Оператор поручает обработку
            персональных данных в вышеуказанных целях, включая трансграничную
            передачу персональных данных, обезличивание, блокирование,
            уничтожение, с использованием средств автоматизации и без
            использования таких средств.
          </div>
          <div class="agreement__paragraph">
            Настоящее согласие на обработку моих персональных данных действует
            до момента выполнения моего запроса и может быть отозвано мною ранее
            в соответствии со статьей 9 Федерального закона от 27.07.2006 года
            №152-ФЗ «О персональных данных» посредством направления
            соответствующего письменного заявления по почтовому адресу
            Оператора, указанного в настоящем согласии, или в электронной форме
            посредством направления запроса на электронный адрес
            info@audi-sever.ru.
          </div>
          <div class="agreement__paragraph">
            ООО "РОЛЬФ", Филиал АЦ Север ведет деятельность на территории
            Российской Федерации в соответствии с законодательством Российской
            Федерации. Предлагаемые Оператором в заявленных в настоящем согласии
            целях товары/услуги/работы доступны к получению на территории
            Российской Федерации. Мониторинг потребительского поведения лиц,
            находящихся за пределами Российской Федерации, Оператором не
            ведется.
          </div>
          <div class="agreement__paragraph">
            © 2018. Ауди Центр Север. Все права защищены
          </div>
        </template>
        <template v-if="type === 'communication'">
          <div class="agreement__paragraph">
            Настоящим даю согласие на обработку моих вышеуказанных персональных
            данных Операторам: Оператор 1: ООО "ФОЛЬКСВАГЕН Груп Рус" (248926,
            г. Калуга, ул. Автомобильная, д. 1 / (почтовый адрес) адрес Филиала
            в г. Москве) 117485, г. Москва, ул. Обручева, д. 30/1); Оператор 2:
            ООО "РОЛЬФ", Филиал АЦ Север (125445, г. Москва, Ленинградское ш.,
            д. 63Б) (прим: точная информация об Операторе 2 (фирменное
            наименование и юридический адрес) размещена на официальном сайте
            Оператора 2) с целями: учета предоставленной информации в базах
            данных; проведения статистических исследований, а также
            исследований, направленных на улучшение качества продукции и услуг;
            проведения маркетинговых программ, в том числе, для продвижения
            товаров, работ, услуг на рынке; информирования меня о новых товарах
            и услугах Операторов и партнеров Операторов (например, посредством
            отправки журналов, отправки приглашений на презентации продуктов,
            сообщений о технических нововведениях, предстоящих работах по
            сервисному обслуживанию, условиях покупки нового автомобиля и т.д.)
            с помощью различных средств связи, а именно посредством: интернет;
            сообщений на адрес электронной почты; коротких текстовых сообщений
            (SMS) и мультимедийных сообщений (MMS) на номер телефона; а также
            посредством использования информационно-коммуникационных сервисов,
            таких как Viber, WhatsApp и тому подобных; телефонных звонков.
          </div>
          <div class="agreement__paragraph">
            Я разрешаю совершать со своими персональными данными следующие
            действия: сбор, систематизацию, накопление, хранение (в электронном
            виде и на бумажном носителе), уточнение (обновление, изменение),
            использование, распространение (в том числе передачу) моих
            персональных данных третьим лицам, с которыми у Операторов имеются
            действующие договоры, в рамках которых Операторы поручают обработку
            персональных данных в вышеуказанных целях, включая трансграничную
            передачу персональных данных, обезличивание, блокирование,
            уничтожение, с использованием средств автоматизации и без
            использования таких средств. В целях проведения маркетинговых
            программ, в том числе для продвижения товаров, работ и услуг, ООО
            «ФОЛЬКСВАГЕН Груп Рус» и ООО "РОЛЬФ", Филиал АЦ Север могут
            заключать соответствующие Договоры с третьими лицами относительно
            условий предоставления мне финансовых услуг.
          </div>
          <div class="agreement__paragraph">
            Настоящим я даю свое согласие на получение информации о предлагаемых
            такими третьими лицами финансовых услугах. Указанная информация
            может быть доведена до моего сведения как ООО "РОЛЬФ", Филиал АЦ
            Север, так и самими компаниями-партнерами ООО "РОЛЬФ", Филиал АЦ
            Север, предлагающими такие финансовые услуги, включая следующие: ООО
            «ФОЛЬКСВАГЕН Груп Рус», предлагающими такие финансовые услуги,
            включая следующие: ООО «Фольксваген Банк РУС» (117485, г. Москва,
            ул. Обручева, д. 30/1, стр.1, ИНН: 7750005605, лицензия ЦБ РФ
            №3500), ООО «ФВ Груп Финанц» (Россия, 107045, г. Москва, ул.
            Трубная, 12, ИНН: 7702349370); ООО «Фольксваген Финансовые Услуги
            РУС» (Россия, 107045, г. Москва, ул. Трубная, 12, ИНН: 7702656396.
            Полный перечень компаний-партнеров ООО «ФОЛЬКСВАГЕН Груп Рус» в
            области предоставления финансовых услуг размещен на сайте
            www.audi.ru в разделе Audi Financial Services.
          </div>
          <div class="agreement__paragraph">
            Настоящее согласие на обработку персональных данных действует до
            момента его отзыва в соответствии со статьей 9 Федерального закона
            от 27.07.2006 г. №152-ФЗ «О персональных данных» посредством
            предоставления письменного заявления по почтовым адресам Операторов,
            указанных в настоящем согласии или в электронной форме посредством
            заполнения специальной формы «Обратная связь» на сайте
            www.audi-sever.ru.
          </div>
          <div class="agreement__paragraph">
            ООО "РОЛЬФ", Филиал АЦ Север ведет деятельность на территории
            Российской Федерации в соответствии с законодательством Российской
            Федерации. Предлагаемые Оператором в заявленных в настоящем согласии
            целях товары/услуги/работы доступны к получению на территории
            Российской Федерации. Мониторинг потребительского поведения лиц,
            находящихся за пределами Российской Федерации, Оператором не
            ведется.
          </div>
          <div class="agreement__paragraph">
            © 2018. Ауди Центр Север. Все права защищены
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "full-agreement",
  props: ["type"],
  methods: {
    hideSelf() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.agreement {
  &__container {
    top: 30px;
    height: calc(100vh - 90px);
    left: 15px;
    width: calc(100vw - 30px);
    position: fixed;
    z-index: 1200;
    background: #fff;
    padding: 40px 20px;
    cursor: default;
  }

  &__content {
    font-size: 14px;
    overflow: auto;
    max-height: 100%;
  }

  &__title {
    font-size: 16px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
  }

  &__paragraph {
    margin-bottom: 10px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  &__close {
    position: absolute;
    right: 20px;
    top: 20px;
    width: 15px;
    height: 15px;
    cursor: pointer;
  }
}
</style>
